( function ( _s ) {
	_s.fn.digitalExperienceComponent = function () {
		return this.el.forEach( el => {
			let _el = _s( el );
			let config = JSON.parse( _el.attr( 'config' ) || '{}' );
			const _header = _s( '#digital-experience-header' );
			const _panel = _el.find( '.de-panel' );
			const _sectionCheckboxes = _panel.find( '.de-panel-section-title [type="checkbox"]' );
			let _sectionItemCheckboxes = _panel.find(
				'.de-panel-section-item-title [type="checkbox"]'
			);
			const _modals = _el.find( '.de-modals .digital-experience-modal' );
			const modelProjects = Object.values( config?.model_projects ) || [];
			const importantSites = Object.values( config?.important_sites ) || [];
			const ranges = [];
			const rangeColors = config?.range_colors ?? [];
			const defaultRangeColors = [
				{
					color: '#494F00',
					species: 'hooded',
				},
				{
					color: '#7F8A3A',
					species: 'black crowned',
				},
				{
					color: '#C9A46C',
					species: 'eurasian',
				},
				{
					color: '#D926D9',
					species: 'demoiselle demis',
				},
				{
					color: '#FB4255',
					species: 'siberian',
				},
				{
					color: '#FFC44D',
					species: 'grey crowned',
				},
				{
					color: '#BF2333',
					species: 'red crowned',
				},
				{
					color: '#C98A0D',
					species: 'brolga',
				},
				{
					color: '#AD3069',
					species: 'wattled',
				},
				{
					color: '#5D7981',
					species: 'black necked',
				},
				{
					color: '#64AABB',
					species: 'sarus',
				},
				{
					color: '#065266',
					species: 'blue',
				},
				{
					color: '#4D26D9',
					species: 'sandhill',
				},
				{
					color: '#26D6D9',
					species: 'white naped',
				},
				{
					color: '#3DDF7F',
					species: 'whooping',
				},
			];
			let currentViewIndex = false;
			let currentViewProgress = 0;
			let finalModalShown = false;
			const initialZoom = config?.initial_zoom ? config.initial_zoom : 2;
			const mapMaxZoom = config?.max_zoom ? config.max_zoom : 7;
			const clusterMaxZoom = mapMaxZoom - 1;
			const initialCoordinates =
				config.initial_coordinates?.latitude.length &&
				config.initial_coordinates?.longitude.length
					? config.initial_coordinates
					: false;

			if ( ! config ) return;

			const toggleMapElementsByIdList = ( dataIdList, show ) => {
				if ( ! el.mapboxMapInstance ) return;

				dataIdList.forEach( elementId => {
					if ( el.mapboxMapInstance.getLayer( elementId ) ) {
						el.mapboxMapInstance.setLayoutProperty(
							elementId,
							'visibility',
							show ? 'visible' : 'none'
						);
					} else {
						el._markers
							.filter( '#' + elementId )
							.toggleClass( 'hidden', ! show )
							.attr( {
								tabindex: show ? 0 : -1,
								'aria-hidden': show ? 'false' : 'true',
							} );
					}
				} );
			};

			const toggleMapElementsByType = e => {
				if ( ! el.mapboxMapInstance ) return;

				const target = e.target;
				const _target = _s( target );
				const controlType = _target.attr( 'data-control-type' );

				_sectionItemCheckboxes.filter( `[name^="${ controlType }"]` ).each( checkbox => {
					checkbox.checked = target.checked;

					const dataId = _s( checkbox ).attr( 'data-element-id' );

					if ( typeof dataId !== 'string' || ! dataId.length ) return;

					const dataIdList = dataId.split( ',' );

					toggleMapElementsByIdList( dataIdList, target.checked );
				} );

				_s( el ).trigger( 'type-toggle', { type: controlType, add: target.checked } );
			};

			const toggleMapElement = e => {
				if ( ! el.mapboxMapInstance ) return;

				const target = e.target;
				const _target = _s( target );
				const dataId = _target.attr( 'data-element-id' );

				if ( typeof dataId !== 'string' || ! dataId.length ) return;

				const dataIdList = dataId.split( ',' );

				toggleMapElementsByIdList( dataIdList, target.checked );

				_s( el ).trigger( 'element-toggle', { id: dataId, add: target.checked } );
			};

			_sectionCheckboxes.on( 'change', toggleMapElementsByType );

			_sectionItemCheckboxes.on( 'change', toggleMapElement );

			const addRangesToPanel = () => {
				const _panelRangesContainer = _panel.find( '#de-panel-ranges' );

				_panelRangesContainer.find( '> span' ).remove();

				ranges.sort( ( a, b ) => a.id - b.id );

				ranges.forEach( ( range, index ) => {
					const dataLayer = [ range.fillId, range.lineId ];
					const dataLayerStringValue = dataLayer.join( ',' );

					const color = el.mapboxMapInstance.getPaintProperty(
						range.fillId,
						'fill-color'
					);

					_panelRangesContainer.append( `
						<div class="de-panel-section-item">
							<div class="de-panel-section-item-title d-flex flex-row align-items-center">
								<input type="checkbox" class="custom-style" name="range-${ index + 1 }" id="range-${
									index + 1
								}" data-element-id="${ dataLayerStringValue }" data-bg-color="${ color }" checked>
								${ range.title }
							</div>
						</div>` );
				} );

				const rangeCheckboxes = el.querySelectorAll( '#de-panel-ranges [type="checkbox"]' );

				_sectionItemCheckboxes = _sectionItemCheckboxes.add( rangeCheckboxes );

				_s( rangeCheckboxes ).checkboxRadio();

				_s( rangeCheckboxes ).on( 'change', toggleMapElement );
			};

			const focusToMarker = ( targetCoordinates, marker = false ) => {
				if ( ! el.mapboxMapInstance ) return;

				const flyToConfig = {
					center: targetCoordinates,
					speed: 0.35,
					essential: true,
				};

				el._markers.removeClass( 'has-focus' );

				if ( marker ) {
					const _marker = el._markers.filter( `#${ marker.marker_id }` );
					const _uncheckedTargetMarkerCheckbox = _sectionItemCheckboxes.filter(
						`[data-element-id="${ marker.marker_id }"]:not(:checked)`
					);

					if ( _marker.hasClass( 'hidden' ) ) {
						flyToConfig.easing = t => t; // linear
						flyToConfig.speed = 1;

						const onZoomend = () => {
							setTimeout( () => {
								if ( _marker.hasClass( 'hidden' ) ) {
									getCurrentClusters().forEach( cluster => {
										el.mapboxMapInstance
											.getSource( 'points' )
											.getClusterLeaves(
												cluster.id,
												Infinity,
												0,
												( err, clusterLeaves ) => {
													if ( err ) return;
													const targetMarker = clusterLeaves.filter(
														leaf =>
															leaf.properties?.markerId ==
															marker.marker_id
													);

													if ( targetMarker.length ) {
														el.mapboxMapInstance
															.getSource( 'points' )
															.getClusterExpansionZoom(
																cluster.id,
																( err, zoom ) => {
																	if ( err ) return;
																	el.mapboxMapInstance.flyTo( {
																		center: targetCoordinates,
																		zoom: zoom,
																	} );
																}
															);
													}
												}
											);
									} );
								}
							}, 500 );

							el.mapboxMapInstance.off( 'zoomend', onZoomend );
						};

						el.mapboxMapInstance.on( 'zoomend', onZoomend );
					}

					_uncheckedTargetMarkerCheckbox.each( targetMarkerCheckbox => {
						targetMarkerCheckbox.click();
					} );

					_marker.addClass( 'has-focus' );
				}

				el.mapboxMapInstance.flyTo( flyToConfig );
			};

			const openModal = item => {
				_modals.removeClass( 'show' );
				_modals.filter( `[data-marker-id=${ item.marker_id }]` ).addClass( 'show' );
				el._markers.filter( '#' + item.marker_id ).addClass( 'viewed' );

				if ( item.type == 'project' ) {
					if ( currentViewProgress < 100 ) {
						const total = modelProjects.length;
						const viewed = el._markers.filter( '.project-marker.viewed' ).length;

						currentViewProgress = ( viewed * 100 ) / total;

						_header.trigger( 'custom-ev-viewprogress-update', {
							viewProgress: currentViewProgress,
							viewed: viewed,
						} );

						if ( currentViewProgress == 100 ) {
							setTimeout( () => {
								finalModalCheck();
							}, 10000 );
						}
					}

					currentViewIndex = modelProjects.findIndex(
						project => project.marker_id == item.marker_id
					);
				}
			};

			const finalModalCheck = () => {
				if ( currentViewProgress == 100 && ! finalModalShown ) {
					finalModalShown = true;
					_s( window ).trigger( 'icf:digital-experience-open-outro-modal' );
				}
			};

			const getCurrentClusters = () => {
				const allFeatures = el.mapboxMapInstance.querySourceFeatures( 'points' );
				const clusters = allFeatures
					.filter( f => f.properties?.cluster )
					.filter( ( cluster, index, self ) => {
						return index === self.findIndex( c => c.id === cluster.id );
					} ); // deduplicate

				return clusters;
			};

			const getUnclusteredPoints = () => {
				const allFeatures = el.mapboxMapInstance.querySourceFeatures( 'points' );
				const unclustered = allFeatures
					.filter( f => ! ( f.properties?.cluster || false ) )
					.filter( ( point, index, self ) => {
						return (
							index ===
							self.findIndex(
								p => p.properties.markerId === point.properties.markerId
							)
						);
					} );

				return unclustered;
			};

			const initClusters = () => {
				const checkMarkers = e => {
					const clusters = getCurrentClusters();
					const unclustered = getUnclusteredPoints();

					clusters.forEach( c => {
						el.mapboxMapInstance
							.getSource( 'points' )
							.getClusterLeaves( c.id, Infinity, 0, ( err, clusterLeaves ) => {
								if ( err ) return;
								clusterLeaves.forEach( clusterLeave => {
									el._markers
										.filter( `#${ clusterLeave.properties.markerId }` )
										.addClass( 'hidden' )
										.attr( { tabindex: -1, 'aria-hidden': 'true' } );
								} );
							} );
					} );

					unclustered.forEach( unclusteredPoint => {
						if (
							_sectionItemCheckboxes.filter(
								`[data-element-id="${ unclusteredPoint.properties.markerId }"]:checked`
							).length
						) {
							el._markers
								.filter( `#${ unclusteredPoint.properties.markerId }` )
								.removeClass( 'hidden' )
								.attr( { tabindex: 0, 'aria-hidden': 'false' } );
						}
					} );
				};

				// Zoom in on cluster click
				el.mapboxMapInstance.on( 'click', 'clusters', e => {
					const features = el.mapboxMapInstance.queryRenderedFeatures( e.point, {
						layers: [ 'clusters' ],
					} );
					const clusterId = features[ 0 ].properties.cluster_id;

					el.mapboxMapInstance
						.getSource( 'points' )
						.getClusterExpansionZoom( clusterId, ( err, zoom ) => {
							if ( err ) return;
							el.mapboxMapInstance.flyTo( {
								center: features[ 0 ].geometry.coordinates,
								zoom: zoom,
							} );
						} );
				} );

				el.mapboxMapInstance.on(
					'mouseenter',
					'clusters',
					() => ( el.mapboxMapInstance.getCanvas().style.cursor = 'pointer' )
				);

				el.mapboxMapInstance.on(
					'mouseleave',
					'clusters',
					() => ( el.mapboxMapInstance.getCanvas().style.cursor = '' )
				);

				el.mapboxMapInstance.on( 'zoom', e => checkMarkers( e ) );

				el.mapboxMapInstance.on( 'zoomend', e => checkMarkers( e ) );

				el.mapboxMapInstance.on( 'sourcedata', e => checkMarkers( e ) );

				el.mapboxMapInstance.on( 'idle', () => {
					const source = el.mapboxMapInstance.getSource( 'points' );

					if ( ! source ) return;

					checkMarkers();
				} );

				_s( el ).on( 'check-markers', () => {
					checkMarkers();
				} );
			};

			const addMarkers = () => {
				if ( ! el.mapboxMapInstance ) return;
				const coords = [];

				const projectMarkerTemplate = `
					<div>
						<svg viewBox="-1 -1 72 80" width="72" height="80" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<defs>
								<clipPath id="[clip_id]-1">
									<path d="M58 0C64.63 0 70 5.37 70 12V58C70 64.63 64.63 70 58 70H41.38L36.46 78L30.71 70H12C5.37 70 0 64.63 0 58V12C0 5.37 5.37 0 12 0H58Z"/>
								</clipPath>
								<linearGradient id="[clip_id]-overlayGradient" x1="0" y1="1" x2="0" y2="0">
									<stop offset="0%" stop-color="rgb(10,78,125)" stop-opacity="0.4"/>
									<stop offset="100%" stop-color="rgb(10,78,125)" stop-opacity="0.4"/>
								</linearGradient>
							</defs>
  							<image href="[thumbnail_url]" xlink:href="[thumbnail_url]" width="70" height="78" clip-path="url(#[clip_id]-1)" preserveAspectRatio="xMidYMid slice" crossorigin="anonymous"/>
							<rect  x="0" y="0" width="70" height="78" clip-path="url(#[clip_id]-1)" fill="url(#[clip_id]-overlayGradient)" pointer-events="none"/>
  							<path d="M58 0C64.63 0 70 5.37 70 12V58C70 64.63 64.63 70 58 70H41.38L36.46 78L30.71 70H12C5.37 70 0 64.63 0 58V12C0 5.37 5.37 0 12 0H58Z" fill="none" stroke="white" stroke-width="2"/>
						</svg>
						<div class="hover-info d-flex flex-row align-items-center">
							<div class="marker-thumbnail-wrapper">
								<svg viewBox="-1 -1 72 80" width="72" height="80" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<defs>
										<clipPath id="[clip_id]-2">
										<path d="M58 0C64.63 0 70 5.37 70 12V58C70 64.63 64.63 70 58 70H41.38L36.46 78L30.71 70H12C5.37 70 0 64.63 0 58V12C0 5.37 5.37 0 12 0H58Z"/>
										</clipPath>
									</defs>
									<image href="[thumbnail_url]" xlink:href="[thumbnail_url]" width="70" height="78" clip-path="url(#[clip_id]-2)" preserveAspectRatio="xMidYMid slice" crossorigin="anonymous"/>
									<path d="M58 0C64.63 0 70 5.37 70 12V58C70 64.63 64.63 70 58 70H41.38L36.46 78L30.71 70H12C5.37 70 0 64.63 0 58V12C0 5.37 5.37 0 12 0H58Z" fill="none" stroke="white" stroke-width="2"/>
								</svg>
							</div>
							<div>
								<span class="title">[title]</span>
								<span class="location">[location]</span>
							</div>
						</div>
					</div>
				`;

				const siteMarkerTemplate = `
					<div>
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="27" height="33" viewBox="0 0 36 44" fill="none">
							<path d="M18 1C21.3644 1 24.6524 2.00742 27.4482 3.89355C30.244 5.77962 32.4215 8.45935 33.707 11.5928C34.9925 14.7261 35.329 18.1733 34.6738 21.499C34.0186 24.8248 32.4012 27.8816 30.0244 30.2812L18.7109 41.7041L18 42.4209L17.2891 41.7041L5.97559 30.2812C3.59885 27.8816 1.98137 24.8248 1.32617 21.499C0.671005 18.1733 1.0075 14.7261 2.29297 11.5928C3.57849 8.45935 5.75601 5.77962 8.55176 3.89355C11.3476 2.00742 14.6356 1 18 1ZM18 15.5645C17.3254 15.5645 16.6763 15.8347 16.1963 16.3193C15.716 16.8043 15.4443 17.4643 15.4443 18.1543C15.4444 18.8442 15.716 19.5043 16.1963 19.9893C16.6763 20.4738 17.3254 20.7441 18 20.7441C18.6746 20.7441 19.3237 20.4738 19.8037 19.9893C20.284 19.5043 20.5556 18.8442 20.5557 18.1543C20.5557 17.4643 20.284 16.8043 19.8037 16.3193C19.3237 15.8347 18.6746 15.5645 18 15.5645Z" fill="#0A4E7D" stroke="white" stroke-width="2"/>
						</svg>
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13" height="13" viewBox="0 0 22 22" fill="none" class="viewed-icon">
							<path d="M11 8.25C10.2706 8.25 9.57114 8.53973 9.05542 9.05546C8.53969 9.57118 8.24996 10.2707 8.24996 11C8.24996 11.7293 8.53969 12.4288 9.05542 12.9445C9.57114 13.4603 10.2706 13.75 11 13.75C11.7293 13.75 12.4288 13.4603 12.9445 12.9445C13.4602 12.4288 13.75 11.7293 13.75 11C13.75 10.2707 13.4602 9.57118 12.9445 9.05546C12.4288 8.53973 11.7293 8.25 11 8.25ZM11 15.5833C9.78438 15.5833 8.6186 15.1004 7.75905 14.2409C6.89951 13.3814 6.41663 12.2156 6.41663 11C6.41663 9.78442 6.89951 8.61864 7.75905 7.75909C8.6186 6.89955 9.78438 6.41667 11 6.41667C12.2155 6.41667 13.3813 6.89955 14.2409 7.75909C15.1004 8.61864 15.5833 9.78442 15.5833 11C15.5833 12.2156 15.1004 13.3814 14.2409 14.2409C13.3813 15.1004 12.2155 15.5833 11 15.5833ZM11 4.125C6.41663 4.125 2.50246 6.97583 0.916626 11C2.50246 15.0242 6.41663 17.875 11 17.875C15.5833 17.875 19.4975 15.0242 21.0833 11C19.4975 6.97583 15.5833 4.125 11 4.125Z" fill="white"/>
						</svg>
						<div class="hover-info d-flex flex-row align-items-center">
							<div>
								<span class="title">[title]</span>
								<span class="location">[location]</span>
							</div>	
						</div>
					</div>
				`;

				modelProjects.concat( importantSites ).forEach( item => {
					const markerElement = document.createElement( 'div' );
					const _markerElement = _s( markerElement );
					const newMarker = new mapboxgl.Marker( markerElement, { anchor: 'bottom' } )
						.setLngLat( [ item.longitude, item.latitude ] )
						.addTo( el.mapboxMapInstance );

					if ( item.type == 'project' ) {
						_markerElement.addClass( 'project-marker' );

						markerElement.innerHTML = projectMarkerTemplate
							.replaceAll( '[clip_id]', `clip-${ item.marker_id }` )
							.replaceAll( '[thumbnail_url]', item.map_icon_thumbnail.url )
							.replace( '[title]', item.title )
							.replace( '[location]', item.location );
					} else {
						_markerElement.addClass( 'site-marker' );

						markerElement.innerHTML = siteMarkerTemplate
							.replaceAll( '[thumbnail_url]', item.map_icon_thumbnail.url )
							.replace( '[title]', item.title )
							.replace( '[location]', item.location );

						coords.push( {
							coordinates: [ item.longitude, item.latitude ],
							item_type: item.type,
							marker_id: item.marker_id,
						} );
					}

					_markerElement.addClass(
						item.type == 'project' ? 'project-marker' : 'site-marker'
					);

					newMarker.getElement().id = item.marker_id;

					newMarker.getElement().tabIndex = 0;

					_markerElement.on( 'click keyup', e => {
						if (
							( e.type == 'keyup' && ( e.key === 'Enter' || e.keyCode === 13 ) ) ||
							e.type == 'click'
						) {
							openModal( item );

							focusToMarker( [ item.longitude, item.latitude ], item );
						}
					} );

					el._markers = el._markers
						? el._markers.add( el.querySelector( `#${ item.marker_id }` ) )
						: _s( el.querySelector( `#${ item.marker_id }` ) );
				} );

				if ( ! coords.length ) return;

				// Convert coordinates → GeoJSON FeatureCollection
				const buildGeoJSON = coordinatesSet => {
					return {
						type: 'FeatureCollection',
						features: coordinatesSet.map( c => ( {
							type: 'Feature',
							geometry: {
								type: 'Point',
								coordinates: c.coordinates,
							},
							properties: {
								markerId: c.marker_id,
								itemType: c.item_type,
							},
						} ) ),
					};
				};

				// Add the GeoJSON source with clustering enabled
				el.mapboxMapInstance.addSource( 'points', {
					type: 'geojson',
					data: buildGeoJSON( coords ),
					cluster: true,
					clusterRadius: 15,
					clusterMaxZoom: clusterMaxZoom,
				} );

				// --- Cluster circles
				el.mapboxMapInstance.addLayer( {
					id: 'clusters',
					type: 'circle',
					source: 'points',
					filter: [ 'has', 'point_count' ],
					paint: {
						'circle-color': '#0a4e7d',
						'circle-radius': 15,
					},
				} );

				// --- Cluster count (white text)
				el.mapboxMapInstance.addLayer( {
					id: 'cluster-count',
					type: 'symbol',
					source: 'points',
					filter: [ 'has', 'point_count' ],
					layout: {
						'text-field': [ 'get', 'point_count_abbreviated' ],
						'text-size': 12,
					},
					paint: {
						'text-color': '#fff',
					},
				} );

				// --- Unclustered points
				el.mapboxMapInstance.addLayer( {
					id: 'unclustered',
					type: 'circle',
					source: 'points',
					filter: [ '!', [ 'has', 'point_count' ] ],
					paint: {
						'circle-color': 'transparent',
						'circle-radius': 0,
						'circle-stroke-width': 0,
						'circle-stroke-color': 'transparent',
					},
				} );

				const updatePointsData = () => {
					const _checkedElements = _sectionItemCheckboxes.filter(
						':not([data-element-id^="ogc-"]):checked'
					);
					const checkedCoords = coords.filter( coord => {
						return _checkedElements.filter( `[data-element-id=${ coord.marker_id }]` )
							.length;
					} );

					el.mapboxMapInstance
						.getSource( 'points' )
						.setData( buildGeoJSON( checkedCoords ) );

					_s( el ).trigger( 'check-markers' );
				};

				_s( el ).on( 'type-toggle', e => {
					const options = e.detail;

					if ( options.type == 'range' ) return;

					updatePointsData();
				} );

				_s( el ).on( 'element-toggle', e => {
					const options = e.detail;

					if ( typeof options.id !== 'string' || options.id.startsWith( 'ogc-' ) ) return;

					updatePointsData();
				} );

				initClusters();
			};

			const viewModelProject = navDirection => {
				if ( ! modelProjects.length || ! el.mapboxMapInstance ) return;

				let targetModelProject = false;

				if ( currentViewIndex === false ) {
					targetModelProject =
						navDirection == 'next'
							? modelProjects[ 0 ]
							: modelProjects[ modelProjects.length - 1 ];
					currentViewIndex = navDirection == 'next' ? -1 : modelProjects.length;
				} else if ( [ 0, modelProjects.length - 1 ].includes( currentViewIndex ) ) {
					targetModelProject =
						navDirection == 'next'
							? currentViewIndex == modelProjects.length - 1
								? modelProjects[ 0 ]
								: modelProjects[ currentViewIndex + 1 ]
							: currentViewIndex == 0
							? modelProjects[ modelProjects.length - 1 ]
							: modelProjects[ currentViewIndex - 1 ];
				} else {
					targetModelProject =
						navDirection == 'next'
							? modelProjects[ currentViewIndex + 1 ]
							: modelProjects[ currentViewIndex - 1 ];
				}

				finalModalCheck();

				if ( targetModelProject ) {
					focusToMarker(
						[ targetModelProject.longitude, targetModelProject.latitude ],
						targetModelProject
					);
					openModal( targetModelProject );
				} else {
					console.log( 'error....', targetModelProject );
				}
			};

			// Direct OGC Collections endpoint (ensure non-empty string)
			const OGC_COLLECTIONS_URL =
				typeof config.ranges_geojson_api_url === 'string' &&
				config.ranges_geojson_api_url.trim()
					? config.ranges_geojson_api_url.trim()
					: null;

			// Mapbox public access token (pk.*) (ensure non-empty string)
			const MAPBOX_TOKEN =
				typeof config.mapbox_token === 'string' && config.mapbox_token.trim()
					? config.mapbox_token.trim()
					: null;

			// If token is missing/empty, do not attempt to initialize Mapbox
			if ( ! MAPBOX_TOKEN ) {
				console.warn( 'Missing Mapbox token. Skipping map initialization.' );
				return;
			}

			mapboxgl.accessToken = MAPBOX_TOKEN;

			const map = new mapboxgl.Map( {
				container: 'map',
				style: 'mapbox://styles/mapbox/streets-v12',
				center: initialCoordinates
					? [
							parseInt( initialCoordinates.longitude ),
							parseInt( initialCoordinates.latitude ),
					  ]
					: [ 20, 0 ],
				zoom: initialZoom,
				projection: 'globe',
				fadeDuration: 0,
				maxZoom: mapMaxZoom,
			} );

			// Ensure oceans gray and land white across style layers
			map.on( 'style.load', () => {
				map.setFog( null );

				map.getStyle().layers.forEach( l => {
					if ( /-label|road-|admin-1-boundary/.test( l.id ) ) {
						map.setLayoutProperty( l.id, 'visibility', 'none' );
					}
				} );

				try {
					const style = map.getStyle();
					const WHITE = '#FFFFFF';
					const WATER_GRAY = '#ededed';

					if ( style && Array.isArray( style.layers ) ) {
						// Background to white
						for ( const layer of style.layers ) {
							if ( layer && layer.type === 'background' ) {
								try {
									map.setPaintProperty( layer.id, 'background-color', WHITE );
								} catch ( _ ) {}
							}
						}

						// Water layers to gray
						for ( const layer of style.layers ) {
							if ( ! layer ) continue;
							const idLower = String( layer.id || '' ).toLowerCase();
							const srcLower = String( layer[ 'source-layer' ] || '' ).toLowerCase();
							const isWater =
								/water|ocean|sea/.test( idLower ) ||
								/water|ocean|sea/.test( srcLower );
							if ( ! isWater ) continue;
							try {
								if ( layer.type === 'fill' ) {
									map.setPaintProperty( layer.id, 'fill-color', WATER_GRAY );
									map.setPaintProperty( layer.id, 'fill-opacity', 1 );
								} else if ( layer.type === 'line' ) {
									map.setPaintProperty( layer.id, 'line-color', WATER_GRAY );
								} else if ( layer.type === 'background' ) {
									map.setPaintProperty(
										layer.id,
										'background-color',
										WATER_GRAY
									);
								}
							} catch ( _ ) {}
						}

						// Land-related fills to white; hide hillshade/terrain rasters
						for ( const layer of style.layers ) {
							if ( ! layer ) continue;
							const idLower = String( layer.id || '' ).toLowerCase();
							const srcLower = String( layer[ 'source-layer' ] || '' ).toLowerCase();
							const looksLand =
								( /land|landcover|landuse|park|scrub|wood|forest|grass|sand|snow|glacier/.test(
									idLower
								) ||
									/land|landcover|landuse|park|scrub|wood|forest|grass|sand|snow|glacier/.test(
										srcLower
									) ) &&
								! ( /water/.test( idLower ) || /water/.test( srcLower ) );

							try {
								if ( layer.type === 'fill' && looksLand ) {
									map.setPaintProperty( layer.id, 'fill-color', WHITE );
									map.setPaintProperty( layer.id, 'fill-opacity', 1 );
								} else if ( layer.type === 'hillshade' ) {
									map.setLayoutProperty( layer.id, 'visibility', 'none' );
								} else if (
									layer.type === 'raster' &&
									( /hillshade/.test( idLower ) ||
										/terrain/.test( idLower ) ||
										/satellite/.test( idLower ) )
								) {
									map.setPaintProperty( layer.id, 'raster-opacity', 0 );
								}
							} catch ( _ ) {}
						}

						// Admin/boundary lines to #999A9A
						for ( const layer of style.layers ) {
							if ( ! layer || layer.type !== 'line' ) continue;
							const id = String( layer.id || '' );
							const srcLayer = String( layer[ 'source-layer' ] || '' ).toLowerCase();
							const looksBoundary =
								/boundary/i.test( id ) ||
								/admin/i.test( id ) ||
								/boundary/.test( srcLayer ) ||
								/admin/.test( srcLayer );
							if ( looksBoundary ) {
								try {
									map.setPaintProperty( layer.id, 'line-color', '#999A9A' );
									map.setPaintProperty( layer.id, 'line-width', 0.1 );
								} catch ( _ ) {}
							}
						}
					}
				} catch ( _ ) {}
			} );

			el.mapboxMapInstance = map;

			async function fetchJSON( url ) {
				let res = await fetch( url );
				if ( ! res.ok ) throw new Error( 'Request failed: ' + res.status );
				try {
					return await res.json();
				} catch ( _ ) {
					// Retry with f=json if not already present
					const u = new URL( url, location.href );
					if ( ! u.searchParams.has( 'f' ) ) u.searchParams.set( 'f', 'json' );
					res = await fetch( u.toString() );
					if ( ! res.ok ) throw new Error( 'Request failed: ' + res.status );
					return res.json();
				}
			}

			function toAbs( href, base ) {
				try {
					return new URL( href, base ).toString();
				} catch ( _ ) {
					return href;
				}
			}

			function getDefaultRangeColor( collectionTitle ) {
				const range = defaultRangeColors.find( range =>
					range.species.includes(
						collectionTitle
							.toLowerCase()
							.replace( 'cranes', '' )
							.replace( '-', ' ' )
							.trim()
					)
				);

				return range?.color ?? false;
			}

			function hashColor( str ) {
				// Stable hex color derived from HSL for Mapbox compatibility
				let h = 0;
				for ( let i = 0; i < str.length; i++ ) {
					h = ( h * 31 + str.charCodeAt( i ) ) >>> 0;
				}
				const hue = ( h % 360 ) / 360; // 0..1
				const s = 0.7,
					l = 0.5; // 70%, 50%
				function hue2rgb( p, q, t ) {
					if ( t < 0 ) t += 1;
					if ( t > 1 ) t -= 1;
					if ( t < 1 / 6 ) return p + ( q - p ) * 6 * t;
					if ( t < 1 / 2 ) return q;
					if ( t < 2 / 3 ) return p + ( q - p ) * ( 2 / 3 - t ) * 6;
					return p;
				}
				const q = l < 0.5 ? l * ( 1 + s ) : l + s - l * s;
				const p = 2 * l - q;
				const r = Math.round( hue2rgb( p, q, hue + 1 / 3 ) * 255 );
				const g = Math.round( hue2rgb( p, q, hue ) * 255 );
				const b = Math.round( hue2rgb( p, q, hue - 1 / 3 ) * 255 );
				const hex = n => n.toString( 16 ).padStart( 2, '0' );
				return `#${ hex( r ) }${ hex( g ) }${ hex( b ) }`;
			}

			async function loadOgcCollections() {
				try {
					// Validate OGC Collections URL before any request
					const collectionsUrl = OGC_COLLECTIONS_URL;
					if ( ! collectionsUrl ) {
						throw new Error( 'Missing OGC Collections URL' );
					}
					const collections = await fetchJSON( collectionsUrl );
					const list = ( collections && collections.collections ) || [];

					if ( ! list.length ) throw new Error( 'No collections found' );

					// Fetch GeoJSON for each species with limited concurrency
					const CONCURRENCY = 6;
					let nextIndex = 0;

					async function handleOne( i ) {
						const coll = list[ i ];
						const raw_name = coll.title || coll.id || `collection-${ i + 1 }`;
						const name = raw_name.replaceAll( '_', ' ' );
						const geoLink = ( coll.links || [] ).find(
							l => l && /application\/geo\+json/i.test( l.type || '' ) && l.href
						);

						if ( ! geoLink ) return;

						let href = toAbs( geoLink.href, collectionsUrl );
						let data;

						try {
							data = await fetchJSON( href );
						} catch ( _ ) {
							return;
						}

						if ( ! data || data.type !== 'FeatureCollection' ) return;

						const srcId = `ogc-src-${ i }`;
						const fillId = `ogc-fill-${ i }`;
						const lineId = `ogc-line-${ i }`;
						const color =
							rangeColors[ i ] || getDefaultRangeColor( name ) || hashColor( name );

						coll.title = name;

						coll.fillId = fillId;
						coll.lineId = lineId;

						map.addSource( srcId, { type: 'geojson', data } );

						map.addLayer( {
							id: fillId,
							type: 'fill',
							source: srcId,
							paint: { 'fill-color': color, 'fill-opacity': 0.4 },
						} );

						ranges.push( coll );
					}

					async function runner() {
						while ( true ) {
							const i = nextIndex++;
							if ( i >= list.length ) break;
							await handleOne( i );
						}
					}

					await Promise.all(
						Array.from( { length: Math.min( CONCURRENCY, list.length ) }, () =>
							runner()
						)
					);
				} catch ( err ) {
					console.error( err );
				} finally {
					// Update the panel regardless of success or failure
					addRangesToPanel();
					// Move both cluster layers to the very top
					[ 'clusters', 'cluster-count' ].forEach( id => {
						if ( el.mapboxMapInstance.getLayer( id ) )
							el.mapboxMapInstance.moveLayer( id );
					} );
				}
			}

			// Only attempt to load collections if a valid URL is provided
			if ( ! OGC_COLLECTIONS_URL ) {
				console.warn( 'Missing OGC Collections URL. Skipping collection loading.' );
			} else if ( map.loaded() ) {
				loadOgcCollections();
				addMarkers();
			} else {
				map.once( 'load', loadOgcCollections );
				map.once( 'load', addMarkers );
			}

			_header.trigger( 'custom-ev-map-loaded' );

			_el.on( 'custom-ev-next-prev-project', e => {
				viewModelProject( e.detail.navDirection );
			} );

			_el.on( 'custom-ev-panel-toggle', e => {
				_panel.toggleClass( 'show', e.detail.show );
			} );

			_modals.on( 'fr:modal-closed', () => {
				finalModalCheck();
			} );
		} );
	};

	_s( document ).ready( () => {
		const _elements = _s( '.digital-experience-component' );

		if ( _elements.length ) {
			_elements.digitalExperienceComponent();
		}
	} );
} )( window._s );
